var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoneStepEmployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.0003C12 21.4862 12 20.2291 12.781 19.448C13.5621 18.667 14.8192 18.667 17.3333 18.667H30.6667C33.1808 18.667 34.4379 18.667 35.219 19.448C36 20.2291 36 21.4862 36 24.0003V29.3337C36 31.8478 36 33.1049 35.219 33.8859C34.4379 34.667 33.1808 34.667 30.6667 34.667H17.3333C14.8192 34.667 13.5621 34.667 12.781 33.8859C12 33.1049 12 31.8478 12 29.3337V24.0003Z",
    stroke: "#707070",
    strokeWidth: 1.78
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 18.6667L31.3853 17.2324C30.7134 15.6647 30.3775 14.8808 29.7096 14.4404C29.0417 14 28.1889 14 26.4832 14H17.3333C14.8192 14 13.5621 14 12.781 14.781C12 15.5621 12 16.8192 12 19.3333V28",
    stroke: "#707070",
    strokeWidth: 1.78
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 22.667,
    width: 2.66667,
    height: 2.66667,
    rx: 1.33333,
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoneStepEmployment);
export default __webpack_public_path__ + "static/media/undone-step-employment.a777d635397e04b2043c3759cc2e5074.svg";
export { ForwardRef as ReactComponent };